module.exports = __webpack_public_path__ + "static/media/tick-square.810bd3b2.svg";